// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';
import Swiper from 'swiper/js/swiper';
import ScrollToElement from './ScrollToElement';

const fragments = {
  CONTAINER: '[data-fragment="Beer.container"]',
  SWIPER: '[data-fragment="Beer.swiper"]',
  SLIDE: '[data-fragment="Beer.slide"]',
  PREV: '[data-fragment="Beer.prev"]',
  NEXT: '[data-fragment="Beer.next"]',
  PREV_THUMB: '[data-fragment="Beer.prevThumb"]',
  NEXT_THUMB: '[data-fragment="Beer.nextThumb"]',
  NAV_CONTAINER: '[data-fragment="Beer.navContainer"]',
  NAV_SWIPER: '[data-fragment="Beer.navSwiper"]',
  NAV_SLIDE: '[data-fragment="Beer.navSlide"]',
  NAV_PREV: '[data-fragment="Beer.navPrev"]',
  NAV_NEXT: '[data-fragment="Beer.navNext"]',
  NAV: '[data-fragment="Beer.nav"]',
  NAV_TOGGLE: '[data-fragment="Beer.navToggle"]',
  NAV_TAB: '[data-fragment="Beer.navTab"]',
  POINT: '[data-fragment="Beer.point"]',
  POPUP: '[data-fragment="Beer.popup"]',
  POPUP_ARROW: '[data-fragment="Beer.popupArrow"]',
  LOADING: '[data-fragment="Beer.loading"]',
  TEXT: '[data-fragment="Beer.text"]',
  TEXT_INNER: '[data-fragment="Beer.textInner"]',
  BTN_MORE: '[data-fragment="Beer.btnMore"]',
};

export default class Beer extends WebComponent {
  constructor (props) {
    super(props);

    this.state = {
      beerType: 'draft',
      navOpened: false,
      navBeerType: 'draft',
      activePopup: null,
      activePoint: null,
      activeLoading: true,
    };

    this.centerSlides = this.centerSlides.bind(this);
    this.closeNav = this.closeNav.bind(this);
    this.toggleNav = this.toggleNav.bind(this);
    this.goTo = this.goTo.bind(this);
    this.handleNavItemClick = this.handleNavItemClick.bind(this);
    this.handleNavTabClick = this.handleNavTabClick.bind(this);
    this.handleParallax = this.handleParallax.bind(this);
    this.handleSlideChange = this.handleSlideChange.bind(this);
    this.switchThumbs = this.switchThumbs.bind(this);
    this.setActiveSlide = this.setActiveSlide.bind(this);
    this.changeUrl = this.changeUrl.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.showPopup = this.showPopup.bind(this);
    this.hidePopup = this.hidePopup.bind(this);
    this.handlePopupClick = this.handlePopupClick.bind(this);
    this.setPopupPosition = this.setPopupPosition.bind(this);
    this.hideLoading = this.hideLoading.bind(this);
    this.handleLongText = this.handleLongText.bind(this);
    this.toggleLongText = this.toggleLongText.bind(this);
  }

  didMount() {
    this.swiperElements = this.element.querySelectorAll(fragments.SWIPER);
    this.navSwiperElements = this.element.querySelectorAll(fragments.NAV_SWIPER);
    this.navTabs = this.element.querySelectorAll(fragments.NAV_TAB);
    this.container = this.element.querySelector(fragments.CONTAINER);
    this.navContainer = this.element.querySelector(fragments.NAV_CONTAINER);
    this.nav = this.element.querySelector(fragments.NAV);
    this.navToggle = this.element.querySelector(fragments.NAV_TOGGLE);
    this.loading = this.element.querySelector(fragments.LOADING);
    this.popups = this.element.querySelectorAll(fragments.POPUP);
    this.points = this.element.querySelectorAll(fragments.POINT);
    this.swipers = [];
    this.navSwipers = [];
    if (this.element.dataset.beerType === 'bottled') {
      this.setState({
        beerType: 'bottled',
        navBeerType: 'bottled',
      });
    }
    for (let i = 0; i < this.swiperElements.length; i++) {
      this.swipers[i] = new Swiper(this.swiperElements[i], {
        init: false,
        speed: 500,
        followFinger: false,
        simulateTouch: false,
        autoHeight: true,
        // mousewheel: true,
        breakpoints: {
          768: {
            speed: 800,
          },
        },
        navigation: {
          nextEl: this.swiperElements[i].querySelector(fragments.NEXT),
          prevEl: this.swiperElements[i].querySelector(fragments.PREV),
        },
        loop: false,
      });
      this.swipers[i].on('slideChange', () => this.handleSlideChange(this.swipers[i]));
      this.swipers[i].on('init', () => this.switchThumbs(this.swipers[i]));
      this.swipers[i].on('init', () => this.hideLoading());
      this.swipers[i].init();
      this.swipers[i].beerType = this.swiperElements[i].dataset.type;
    }
    for (let i = 0; i < this.navSwiperElements.length; i++) {
      this.navSwipers[i] = new Swiper(this.navSwiperElements[i], {
        init: false,
        speed: 300,
        slidesPerView: 'auto',
        watchOverflow: true,
        navigation: {
          nextEl: this.navSwiperElements[i].querySelector(fragments.NAV_NEXT),
          prevEl: this.navSwiperElements[i].querySelector(fragments.NAV_PREV),
        },
      });
      this.navSwipers[i].on('init', () => this.centerSlides(this.navSwipers[i]));
      this.navSwipers[i].on('resize', () => this.centerSlides(this.navSwipers[i]));
      this.navSwipers[i].init();
    }
    this.setActiveSlide();
    this.on('click', fragments.NAV_TOGGLE, this.toggleNav);
    this.on('click', fragments.NAV_SLIDE, this.handleNavItemClick);
    this.on('click', fragments.NAV_TAB, this.handleNavTabClick);
    this.on('click', fragments.SLIDE, this.closeNav);
    this.on('click', fragments.POPUP, this.handlePopupClick);
    this.on('click', fragments.POINT, this.showPopup);
    this.on('click', fragments.BTN_MORE, this.toggleLongText);
    window.addEventListener('click', this.hidePopup);
    window.addEventListener('resize', this.handleResize);
    // window.addEventListener('touchmove', this.handleScroll);
  }
  centerSlides = (swiper) => {
    if (swiper.isLocked) {
      swiper.$wrapperEl[0].classList.add('beer-nav__swiper-wrapper--center');
    } else {
      swiper.$wrapperEl[0].classList.remove('beer-nav__swiper-wrapper--center');
    }
  };
  closeNav = () => {
    this.setState({
      navOpened: false,
    });
  };
  toggleNav = () => {
    const { navOpened } = this.state;
    this.setState({
      navOpened: !navOpened,
    });
  };
  goTo = (slideId, beerType) => {
    for (let i = 0; i < this.swipers.length; i++) {
      if (this.swipers[i].beerType === beerType) {
        for (let j = 0; j < this.swipers[i].slides.length; j++) {
          if (this.swipers[i].slides[j].getAttribute('id') === slideId) {
            this.swipers[i].slideTo(j);
          }
        }
      }
    }
    this.setState({ beerType: beerType });
  };
  setActiveSlide = () => {
    if (this.element.dataset.initId) {
      for (let i = 0; i < this.swipers.length; i++) {
        for (let j = 0; j < this.swipers[i].slides.length; j++) {
          if (this.swipers[i].slides[j].getAttribute('id') === this.element.dataset.initId) {
            this.goTo(this.element.dataset.initId, this.swipers[i].beerType);
          }
        }
      }
    }
  };
  handleNavItemClick = (e) => {
    this.goTo(e.target.dataset.target, e.target.dataset.type);
    this.closeNav();
    this.changeUrl(null, e.target.dataset.type);
  };
  handleNavTabClick = (e) => {
    this.setState({ navBeerType: e.target.dataset.target });
  };
  handleSlideChange = (swiper) => {
    this.closeNav();
    this.handleParallax(swiper);
    this.switchThumbs(swiper);
    this.changeUrl(swiper, null);
    this.handleLongText(swiper);
    this.setState({
      activePopup: null,
      activePoint: null,
    });
    new ScrollToElement(
      0,
      300,
      'easeOutQuad',
    );
  };
  handleParallax = (swiper) => {
    swiper.slides[swiper.previousIndex].classList.remove('beer__slide--to-left');
    swiper.slides[swiper.previousIndex].classList.remove('beer__slide--to-right');
    if (swiper.previousIndex < swiper.activeIndex) {
      swiper.slides[swiper.activeIndex].classList.add('beer__slide--to-left');
    } else {
      swiper.slides[swiper.activeIndex].classList.add('beer__slide--to-right');
    }
  };
  switchThumbs = (swiper) => {
    let prevThumbSrc = '';
    let nextThumbSrc = '';
    const prevThumb = swiper.$el[0].querySelector(fragments.PREV_THUMB);
    const nextThumb = swiper.$el[0].querySelector(fragments.NEXT_THUMB);
    if (swiper.activeIndex >= 1) {
      prevThumbSrc = swiper.slides[swiper.activeIndex - 1].dataset.thumb;
      prevThumb.src = prevThumbSrc;
    }
    if (swiper.activeIndex + 1 < swiper.slides.length) {
      nextThumbSrc = swiper.slides[swiper.activeIndex + 1].dataset.thumb;
      nextThumb.src = nextThumbSrc;
    }
  };
  changeUrl = (swiper, beerType) => {
    let activeSwiper = swiper;
    if (!activeSwiper) {
      for (let i = 0; i < this.swipers.length; i++) {
        if (this.swipers[i].beerType === beerType) {
          activeSwiper = this.swipers[i];
        }
      }
    }
    const newUrl = activeSwiper.slides[activeSwiper.activeIndex].dataset.url;
    history.replaceState('', '', newUrl);
  };
  handleResize = () => {
    for (let i = 0; i < this.swipers.length; i++) {
      this.swipers[i].updateAutoHeight();
    }
    if (this.state.activePopup && this.state.activePoint) {
      this.setPopupPosition(this.state.activePopup, this.state.activePoint);
    }
  };
  handleScroll = (e) => {
    this.closeNav();
  };
  showPopup = (e) => {
    let activeSwiper = null;
    for (let i = 0; i < this.swipers.length; i++) {
      if (this.swipers[i].beerType === this.state.beerType) {
        activeSwiper = this.swipers[i];
      }
    }
    const popups = activeSwiper.slides[activeSwiper.activeIndex].querySelectorAll(fragments.POPUP);
    for (let i = 0; i < popups.length; i++) {
      if (e.target.dataset.target === popups[i].dataset.type) {
        if (window.innerWidth < 992) {
          new ScrollToElement(
            popups[i],
            600,
            'easeOutQuad',
            70,
          );
        } else {
          this.setState({
            activePopup: popups[i],
            activePoint: e.target,
          });
          this.setPopupPosition(popups[i], e.target);
        }
      }
    }
  };
  hidePopup = (e) => {
    if (!e.target.matches(fragments.POINT)) {
      this.setState({
        activePopup: null,
        activePoint: null,
      });
    }
  };
  handlePopupClick = (e) => {
    let isInside = false;
    if (typeof (e.currentTarget.dataset) != 'undefined') {
      if (e.currentTarget.dataset.fragment === 'Beer.popup' && !e.target.classList.contains('btn')) {
        isInside = true;
      }
    }
    if (isInside) {
        e.stopPropagation();
    }
  };
  setPopupPosition = (popup, point) => {
    const arrow = popup.querySelector(fragments.POPUP_ARROW);
    if (popup.dataset.position === 'left') {
      popup.style.left = `${point.getBoundingClientRect().left - popup.offsetWidth - 40}px`;
    }
    if (popup.dataset.position === 'right') {
      popup.style.left = `${point.getBoundingClientRect().left + point.offsetWidth + 40}px`;
    }
    const top = point.getBoundingClientRect().top - (popup.offsetHeight / 2) + (point.offsetHeight / 2);
    if (top <= 80) {
      popup.style.top = '80px';
      arrow.style.top = `${point.getBoundingClientRect().top + (point.offsetHeight / 2) - 90}px`;
    } else {
      popup.style.top = `${top}px`;
      arrow.style.top = 'calc(50% - 1rem)';
    }
  };

  hideLoading = () => {
    setTimeout(() => {
      this.setState({
        activeLoading: false,
      });
    }, 500);
  };

  handleLongText = (swiper) => {
    if (window.innerWidth > 991) {
      swiper.$el[0].classList.remove('beer__swiper--text-shown');
      const slide = swiper.slides[swiper.activeIndex];
      const text = slide.querySelector(fragments.TEXT);
      const textInner = slide.querySelector(fragments.TEXT_INNER);
      if (textInner && textInner.offsetHeight > 100) {
        slide.classList.add('beer__slide--text-collapsed');
      }
    }
  };

  toggleLongText = (e) => {
    let swiper = null;
    for (let i = 0; i < this.swipers.length; i++) {
      if (this.swipers[i].beerType === this.state.beerType) {
        swiper = this.swipers[i];
      }
    }
    if (swiper.$el[0].classList.contains('beer__swiper--text-shown')) {
      swiper.$el[0].classList.remove('beer__swiper--text-shown');
    } else {
      swiper.$el[0].classList.add('beer__swiper--text-shown');
    }
  };
  willUnMount() {

  }
  update() {
    const {
      beerType,
      navOpened,
      navBeerType,
      activePopup,
      activePoint,
      activeLoading,
    } = this.state;

    if (beerType === 'draft') {
      classNames(this.container, { 'beer__container--draft': true });
      classNames(this.container, { 'beer__container--bottled': false });
    }
    if (beerType === 'bottled') {
      classNames(this.container, { 'beer__container--draft': false });
      classNames(this.container, { 'beer__container--bottled': true });
    }
    if (navBeerType === 'draft') {
      classNames(this.navContainer, { 'beer-nav__container--draft': true });
      classNames(this.navContainer, { 'beer-nav__container--bottled': false });
    }
    if (navBeerType === 'bottled') {
      classNames(this.navContainer, { 'beer-nav__container--draft': false });
      classNames(this.navContainer, { 'beer-nav__container--bottled': true });
    }
    classNames(this.nav, { 'beer-nav--opened': navOpened });
    for (let i = 0; i < this.navTabs.length; i++) {
      classNames(this.navTabs[i], { 'beer-nav__tab--active': false });
      if (navBeerType === this.navTabs[i].dataset.target) {
        classNames(this.navTabs[i], { 'beer-nav__tab--active': true });
      }
    }
    for (let i = 0; i < this.popups.length; i++) {
      classNames(this.popups[i], { 'beer-popup--active': false });
    }
    if (activePopup) {
      classNames(activePopup, { 'beer-popup--active': true });
      classNames(this.element, { 'beer--popup-active': true });
    } else {
      setTimeout(() => {
        classNames(this.element, { 'beer--popup-active': false });
      }, 300);
    }
    for (let i = 0; i < this.points.length; i++) {
      classNames(this.points[i], { 'beer__point--active': false });
    }
    if (activePoint) {
      classNames(activePoint, { 'beer__point--active': true });
    }
    classNames(this.loading, { 'beer__loading--active': activeLoading });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Beer.js